import { Link } from "react-router-dom";
import { CLINIC, waLink, telLink } from "@/lib/clinic";
import { Phone, MessageCircle, MapPin, Mail, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 grain-overlay text-slate-200" style={{ background: "linear-gradient(180deg,#0C1B33,#0A1F3D)" }} data-testid="site-footer">
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl grid place-items-center text-white font-serif text-lg"
                 style={{ background: "linear-gradient(135deg,#0A6EBD,#16A5B8)" }}>A</div>
            <div>
              <div className="font-serif text-xl text-white">{CLINIC.name}</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-teal-300 font-semibold">Compassionate Care</div>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-300">
            {CLINIC.tagline}. Serving families across Bhopal with ethical, evidence-based medicine.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-teal-300 font-semibold mb-4">Quick Links</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/doctor" className="hover:text-white">Meet the Doctor</Link></li>
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/diagnostics" className="hover:text-white">Diagnostics</Link></li>
            <li><Link to="/appointment" className="hover:text-white">Book Appointment</Link></li>
            <li><Link to="/teleconsultation" className="hover:text-white">Teleconsultation</Link></li>
            <li><Link to="/blog" className="hover:text-white">Health Blog</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-teal-300 font-semibold mb-4">Visit Us</div>
          <div className="flex gap-3 text-sm text-slate-300">
            <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-teal-300" />
            <div>
              {CLINIC.address.line1}<br />
              {CLINIC.address.line2}<br />
              {CLINIC.address.city} – {CLINIC.address.pin}<br />
              {CLINIC.address.state}
            </div>
          </div>
          <div className="mt-4 flex items-center gap-3 text-sm">
            <Clock className="h-4 w-4 text-teal-300" />
            <span>Mon–Sat · 5:00 PM – 8:00 PM · Sun by appointment</span>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-teal-300 font-semibold mb-4">Contact</div>
          <a href={telLink()} className="flex items-center gap-3 text-sm hover:text-white" data-testid="footer-phone">
            <Phone className="h-4 w-4 text-teal-300" /> {CLINIC.phoneDisplay}
          </a>
          <a href={waLink("Hello Aarogya Clinic")} target="_blank" rel="noreferrer"
             className="mt-2 flex items-center gap-3 text-sm hover:text-white" data-testid="footer-whatsapp">
            <MessageCircle className="h-4 w-4 text-teal-300" /> WhatsApp Chat
          </a>
          <a href={`mailto:${CLINIC.email}`} className="mt-2 flex items-center gap-3 text-sm hover:text-white" data-testid="footer-email">
            <Mail className="h-4 w-4 text-teal-300" /> {CLINIC.email}
          </a>
          <Link to="/appointment" className="mt-5 inline-flex rounded-full px-5 py-2.5 text-sm font-semibold text-white"
                style={{ background: "#0A6EBD" }} data-testid="footer-book-btn">
            Book Appointment
          </Link>
        </div>
      </div>
      <div className="relative z-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Aarogya Clinic · All rights reserved.</div>
          <div className="flex gap-4">
            <Link to="/faqs" className="hover:text-white">FAQs</Link>
            <Link to="/contact" className="hover:text-white">Contact</Link>
            <Link to="/admin/login" className="hover:text-white">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
